import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/page-components/blogs/server-components/blog-details-server.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/v1/common-components/page-layout/PageLayout.tsx");
